import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchDescriptionTasks } from "../../../../../store/slices/DescriptionTask";
import {
  setAssociateInstallation,
  setAssoInstaPiechart,
} from "../../../../../store/slices/salesFinanceSlice";
import { fetchSalesTaxes } from "../../../../../store/slices/salesTaxesSlice";
import { fetchQuotations } from "../../../../../store/slices/hourlyRates";
import { fetchOtherExpenses } from "../../../../../store/slices/otherexpenses";
import { fetchEmployees } from "../../../../../store/slices/employeeAdminSlice";
import { fetchAllProjects } from "../../../../../store/slices/projectsSlice";
import { getMyTrainings } from "../../../../../store/slices/MyTraining/myTrainings";
import { useCurrencySymbol } from "../../../../../utils/currencyUtils";
import CommaConvert from "../../../../../utils/CommaConvert";
import {
  parseAmountNumber,
  formatAmountComma,
} from "../../../../../utils/decimalAmountUtils";
import {
  canonicalInstallationAssociatedTaskDescription,
  filterInstallationAssociatedExpenseEntriesForAggregation,
  getInstallationQuotedTrainingDisplayAmount,
  isTrainingExpenseDisplayRow,
} from "../../../../../utils/trainingOtherExpenseSync";
import {
  getLoggedSalesUserId,
  getPerdiemAndAverageCostFromExpenses,
  scopeOtherExpensesForUser,
} from "../../../../../utils/salespersonRatesScope";

const SalesFinanceEfforts = ({
  filteredQuotation,
  matchedProjects,
  currentPerson,
  AssociatedRef,
  tasks,
  perdiemRate: perdiemRateProp,
  averageCostRate: averageCostRateProp,
}) => {
  const dispatch = useDispatch();
  const currency = useCurrencySymbol();
  const USAComma = CommaConvert();
  const formatMoneyComma = formatAmountComma;
  const { employees } = useSelector((state) => state.employees);
  const { mytrainings } = useSelector((state) => state.myTrainings);
  const { projects } = useSelector((state) => state.projects);
  const [perdiem, setperdiem] = useState(0);
  const [averagecost, setaveragecost] = useState(0);

  const { items: otherExpenses } = useSelector((state) => state.otherExpenses);
  const loggedInUserId = useSelector((state) => state.leads.loggedInUserId);
  const email = typeof localStorage !== "undefined" ? localStorage.getItem("email") : "";
  const loggedUserId = useMemo(
    () => getLoggedSalesUserId(loggedInUserId, employees, email),
    [loggedInUserId, employees, email]
  );
  const [, setFsfasfas] = useState([]);

  const [matchedEntries, setMatchedEntries] = useState([]);
  const [filteredMatchedEntries, setFilteredMatchedEntries] = useState([]);

  console.log("DSgsdgsd", filteredMatchedEntries);
  useEffect(() => {
    dispatch(fetchDescriptionTasks());
    dispatch(fetchSalesTaxes());
    dispatch(fetchQuotations());
    dispatch(fetchOtherExpenses());
    dispatch(fetchEmployees());
    dispatch(fetchAllProjects());
    dispatch(getMyTrainings());
  }, [dispatch]);




  useEffect(() => {
    const matchedProjectIds = matchedProjects
      .filter(
        (project) =>
          project.TypeService &&
          project.TypeService.toLowerCase().includes("installation")
      )
      .map((project) => project._id);

    const matchedDescription = tasks
      .filter((task) => matchedProjectIds.includes(task.projectid))
      .sort((a, b) => {
        if (a.projectid < b.projectid) return -1;
        if (a.projectid > b.projectid) return 1;
        return 0;
      });

    setFsfasfas(matchedDescription)
    const filteredMatchedDescription = matchedDescription.filter((task) => {
      const employeeMatch = employees.find(
        (emp) => emp._id === task.taskownerid
      );
      return employeeMatch;
    });

    const groupedByTaskOwner = filteredMatchedDescription.reduce((acc, task) => {
      const ownerId = task.taskownerid;
      if (!acc[ownerId]) {
        acc[ownerId] = [];
      }
      acc[ownerId].push(task);
      return acc;
    }, {});

    const groupedArray = Object.entries(groupedByTaskOwner).map(
      ([taskownerid, entries]) => {
        // Get descriptions that appear in all persons
        const allDescriptions = Object.values(groupedByTaskOwner).flatMap(entries =>
          entries.map(entry => entry.description)
        );

        // Count frequency of each description
        const descriptionFrequency = {};
        allDescriptions.forEach(desc => {
          descriptionFrequency[desc] = (descriptionFrequency[desc] || 0) + 1;
        });

        // Get the total number of persons
        const totalPersons = Object.keys(groupedByTaskOwner).length;

        // Sort entries: descriptions that appear in all persons first, then others
        const sortedEntries = [...entries].sort((a, b) => {
          const appearsInAllA = descriptionFrequency[a.description] === totalPersons;
          const appearsInAllB = descriptionFrequency[b.description] === totalPersons;

          // If both appear in all persons or both don't, sort alphabetically
          if (appearsInAllA && !appearsInAllB) return -1;
          if (!appearsInAllA && appearsInAllB) return 1;

          // If same category, sort alphabetically
          return a.description.localeCompare(b.description);
        });

        const updatedEntries = sortedEntries.map((entry) => {
          return {
            ...entry,
            perdiem: perdiem,
            averagecost: averagecost
          };
        });

        return {
          taskownerid,
          entries: updatedEntries,
        };
      }
    );

    setMatchedEntries(groupedArray);
  }, [tasks, employees, matchedProjects, averagecost, perdiem]);

  // Get person display name with proper numbering
  // Get person display name with manager-specific numbering
  const getPersonDisplayName = useMemo(() => {
    return (taskownerid, groupedPersons) => {
      // Convert currentPerson to array for consistent processing
      const persons = Array.isArray(currentPerson) ? currentPerson : [currentPerson];

      const personData = persons.find(person => person.personId === taskownerid);
      const currentEmployee = employees.find((emp) => emp._id === taskownerid);

      if (personData) {
        // For grouped display, use the pre-calculated display name from grouping logic
        const groupedPerson = groupedPersons?.find(p => p.personId === taskownerid);
        if (groupedPerson?.displayName) {
          return groupedPerson.displayName;
        }

        // Fallback to individual logic if no grouped data
        const serviceType = personData.typeService || "Installation";
        const role = personData.roles?.[0] || "";

        if (role === "Project manager") {
          // Find manager number
          const managers = persons.filter(p => p.roles?.[0] === "Project manager");
          const managerNumber = managers.findIndex(p => p.personId === personData.personId) + 1;
          return `${serviceType} Manager ${managerNumber}`;
        } else if (role === "Operations") {
          // Find which manager this operations person belongs to and their number within that manager
          const managers = persons.filter(p => p.roles?.[0] === "Project manager");
          const operations = persons.filter(p => p.roles?.[0] === "Operations");

          // Group operations by manager (same ProjectID)
          const groupedByManager = managers.map(manager => {
            const managerOperations = operations.filter(op => op.ProjectID === manager.ProjectID);
            return {
              manager,
              operations: managerOperations
            };
          });

          for (const group of groupedByManager) {
            const operationIndex = group.operations.findIndex(op => op.personId === personData.personId);
            if (operationIndex !== -1) {
              // Find manager number for this group
              const managerNumber = managers.findIndex(p => p.personId === group.manager.personId) + 1;
              return `${serviceType} Employee ${managerNumber}.${operationIndex + 1}`;
            }
          }

          // Fallback if no manager found
          return `${serviceType} Employee`;
        } else {
          return `${serviceType} ${role}`;
        }
      }

      // Fallback to employee data if personData not available
      return currentEmployee
        ? `${currentEmployee?.servicetype} ${currentEmployee.customRoles?.[0] || "No Role"}`
        : "Unknown";
    };
  }, [currentPerson, employees]);

  // Group persons by manager and their operations personnel
  // const groupPersonsByManager = useMemo(() => {
  //   if (!currentPerson) return [];

  //   const persons = Array.isArray(currentPerson) ? currentPerson : [currentPerson];

  //   // Group by ProjectID first, then within each project group by manager
  //   const projectsMap = {};

  //   persons.forEach(person => {
  //     const projectId = person.ProjectID;
  //     if (!projectsMap[projectId]) {
  //       projectsMap[projectId] = [];
  //     }
  //     projectsMap[projectId].push(person);
  //   });

  //   const result = [];

  //   // Process each project group
  //   Object.values(projectsMap).forEach(projectGroup => {
  //     // Find managers in this project
  //     const managers = projectGroup.filter(p => p.roles?.includes("Project manager"));

  //     managers.forEach((manager, managerIndex) => {
  //       const managerNumber = managerIndex + 1;

  //       // Add manager with proper display name
  //       result.push({
  //         ...manager,
  //         displayName: `${manager.typeService || "Installation"} Manager ${managerNumber}`,
  //         isManager: true,
  //         managerGroup: `manager_${manager.ProjectID}_${managerNumber}`
  //       });

  //       // Find operations personnel for this manager (same ProjectID)
  //       const operationsForManager = projectGroup.filter(p =>
  //         p.roles?.includes("Operations") && p.ProjectID === manager.ProjectID
  //       );

  //       // Add operations personnel with proper numbering
  //       operationsForManager.forEach((ops, opsIndex) => {
  //         const opsNumber = opsIndex + 1;
  //         result.push({
  //           ...ops,
  //           displayName: `${ops.typeService || "Installation"} Employee ${opsNumber}`,
  //           isManager: false,
  //           managerGroup: `manager_${manager.ProjectID}_${managerNumber}`
  //         });
  //       });
  //     });
  //   });

  //   return result;
  // }, [currentPerson]);

  // Group persons by manager with global numbering
  // Group persons by manager with proper numbering for operations persons
  const groupPersonsByManager = useMemo(() => {
    if (!currentPerson) return [];

    const persons = Array.isArray(currentPerson) ? currentPerson : [currentPerson];

    // Find all managers across all projects
    const allManagers = persons.filter(p => p.roles?.includes("Project manager"));
    const allOperations = persons.filter(p => p.roles?.includes("Operations"));

    // Sort managers to ensure consistent ordering
    const sortedManagers = allManagers.sort((a, b) => {
      const projectCompare = (a.projectName || "").localeCompare(b.projectName || "");
      if (projectCompare !== 0) return projectCompare;
      return (a.personName || "").localeCompare(b.personName || "");
    });

    const result = [];

    // Process each manager globally
    sortedManagers.forEach((manager, managerIndex) => {
      const managerNumber = managerIndex + 1;

      // Add manager with global numbering
      result.push({
        ...manager,
        displayName: `${manager.typeService || "Installation"} Manager ${managerNumber}`,
        isManager: true,
        managerGroup: `manager_${managerNumber}`
      });

      // Find operations personnel for this manager (same ProjectID)
      const operationsForManager = allOperations.filter(op =>
        op.ProjectID === manager.ProjectID
      );

      // Match Project Cost table: keep installation employee order from currentPerson (AllServiceTable rows)
      const sortedOperations = [...operationsForManager].sort((a, b) => {
        const indexA = persons.findIndex((p) => p.personId === a.personId);
        const indexB = persons.findIndex((p) => p.personId === b.personId);
        const orderA = indexA === -1 ? Number.MAX_SAFE_INTEGER : indexA;
        const orderB = indexB === -1 ? Number.MAX_SAFE_INTEGER : indexB;
        return orderA - orderB;
      });

      // Add operations personnel with manager-specific numbering
      sortedOperations.forEach((ops, opsIndex) => {
        const opsNumber = opsIndex + 1;
        result.push({
          ...ops,
          displayName: `${ops.typeService || "Installation"} Employee ${opsNumber}`,
          isManager: false,
          managerGroup: `manager_${managerNumber}`
        });
      });
    });

    return result;
  }, [currentPerson]);

  // Handle both single person object and array of persons with proper grouping
  useEffect(() => {
    if (currentPerson && matchedEntries.length > 0) {
      const groupedPersons = groupPersonsByManager;

      // Extract all person IDs from grouped persons
      const personIds = groupedPersons.map(person => person.personId);

      // Filter matchedEntries to include only those with taskownerid in personIds
      const filtered = matchedEntries.filter(
        (group) => personIds.includes(group.taskownerid)
      );

      // Sort the filtered entries according to the grouped persons order
      const sortedFiltered = filtered.sort((a, b) => {
        const indexA = groupedPersons.findIndex(p => p.personId === a.taskownerid);
        const indexB = groupedPersons.findIndex(p => p.personId === b.taskownerid);
        return indexA - indexB;
      });

      setFilteredMatchedEntries(sortedFiltered);
    } else {
      setFilteredMatchedEntries([]);
    }
  }, [matchedEntries, currentPerson, groupPersonsByManager]);

  const lockedRatesFromItemizedPersons = useMemo(() => {
    const persons = Array.isArray(currentPerson)
      ? currentPerson
      : currentPerson
        ? [currentPerson]
        : [];
    const rowWithRates = persons.find(
      (person) =>
        person?.installationPerdiemRate != null ||
        person?.installationAveragecostRate != null
    );
    if (!rowWithRates) return null;
    return {
      perdiem: Number(rowWithRates.installationPerdiemRate) || 0,
      averagecost: Number(rowWithRates.installationAveragecostRate) || 0,
    };
  }, [currentPerson]);

  useEffect(() => {
    if (lockedRatesFromItemizedPersons) {
      setperdiem(lockedRatesFromItemizedPersons.perdiem);
      setaveragecost(lockedRatesFromItemizedPersons.averagecost);
      return;
    }
    if (perdiemRateProp !== undefined && averageCostRateProp !== undefined) {
      setperdiem(Number(perdiemRateProp) || 0);
      setaveragecost(Number(averageCostRateProp) || 0);
      return;
    }
    const expensesForUser = scopeOtherExpensesForUser(otherExpenses, {
      loggedUserId,
    });
    const { perdiem: p, averagecost: a } =
      getPerdiemAndAverageCostFromExpenses(expensesForUser);
    setperdiem(p);
    setaveragecost(a);
  }, [
    otherExpenses,
    loggedUserId,
    perdiemRateProp,
    averageCostRateProp,
    lockedRatesFromItemizedPersons,
  ]);

  const quotedInstallationTrainingForGroup = useCallback(
    (group) => {
      const assigneeEmp = employees.find((e) => String(e._id) === String(group.taskownerid));
      return getInstallationQuotedTrainingDisplayAmount({
        entries: group.entries,
        matchedProjects,
        assigneeEmp,
        trainingsEnvelope: mytrainings,
        projects,
        currencySymbol: currency,
      });
    },
    [employees, matchedProjects, mytrainings, projects, currency]
  );

  const AssoInstaPiechart = useMemo(() => {
    if (!filteredMatchedEntries?.length) return {};

    const chartData = {};
    filteredMatchedEntries.forEach((group) => {
      const trainKey = canonicalInstallationAssociatedTaskDescription(
        `Training Cost (${currency})`,
        currency
      );
      chartData[trainKey] =
        (chartData[trainKey] || 0) + quotedInstallationTrainingForGroup(group);

      filterInstallationAssociatedExpenseEntriesForAggregation(group.entries).forEach((item) => {
        if (isTrainingExpenseDisplayRow(item)) return;
        const key = canonicalInstallationAssociatedTaskDescription(item.description, currency);
        const value = Number(item.value ?? 0);
        chartData[key] = (chartData[key] || 0) + value;
      });
    });

    const total = Object.values(chartData).reduce((sum, v) => sum + v, 0);
    chartData["Total"] = total;

    const totalTripDuration = filteredMatchedEntries.reduce(
      (sum, group) => sum + (group.entries[0]?.tripduration ?? 0),
      0
    );
    chartData["Trip Duration"] = totalTripDuration;

    return chartData;
  }, [filteredMatchedEntries, currency, quotedInstallationTrainingForGroup]);

  useEffect(() => {
    if (AssoInstaPiechart) {
      dispatch(setAssoInstaPiechart(AssoInstaPiechart));
    }
  }, [dispatch, AssoInstaPiechart]);

  const [totalDataRow, setTotalDataRow] = useState({});

  useEffect(() => {
    dispatch(setAssociateInstallation(totalDataRow.Total));
  }, [totalDataRow, dispatch]);

  useEffect(() => {
    // const dynamicDescriptions = Array.from(
    //   new Set(
    //     filteredMatchedEntries.flatMap((group) =>
    //       group.entries.map((entry) => entry.description)
    //     )
    //   )
    // );

    // const staticHeaders = ["Task Owner ID", "Trip Duration"];
    // const footerFields = ["Perdiem ($)", "Average Cost ($)"];

    // const finalColumns = [...staticHeaders, ...dynamicDescriptions, ...footerFields, "Total"];

    // Compute Total Row for all filtered persons
    const totalRow = {};

    if (filteredMatchedEntries.length > 0) {
      totalRow["Task Owner ID"] = "Total";

      let totalAssociatedCost = 0;

      filteredMatchedEntries.forEach(group => {
        const tripduration = group.entries[0]?.tripduration || 0;

        // Calculate Perdiem and Average Cost for this group
        const groupPerdiem = perdiem * tripduration;
        const groupAvgCost = averagecost * tripduration;

        // Calculate Associated Cost for this group
        let groupAssociatedCost = quotedInstallationTrainingForGroup(group);
        group.entries.forEach((entry) => {
          if (isTrainingExpenseDisplayRow(entry)) return;
          if (entry.value != null && String(entry.value).trim() !== "") {
            groupAssociatedCost += parseAmountNumber(entry.value);
          }
        });
        groupAssociatedCost += groupPerdiem + groupAvgCost;

        totalAssociatedCost += groupAssociatedCost;
      });

      totalRow["Total"] = totalAssociatedCost.toFixed(2);
    }

    setTotalDataRow(totalRow);
  }, [filteredMatchedEntries, perdiem, averagecost, quotedInstallationTrainingForGroup]);

  // Get all unique descriptions across all persons, sorted by common ones first
  const getAllDescriptions = () => {
    const orderedUnique = [];
    const seen = new Set();
    filteredMatchedEntries.forEach((group) => {
      group.entries.forEach((entry) => {
        const c = canonicalInstallationAssociatedTaskDescription(entry.description, currency);
        if (!seen.has(c)) {
          seen.add(c);
          orderedUnique.push(c);
        }
      });
    });

    const descriptionFrequency = {};
    filteredMatchedEntries.forEach((group) => {
      const labels = new Set(
        group.entries.map((e) => canonicalInstallationAssociatedTaskDescription(e.description, currency))
      );
      labels.forEach((c) => {
        descriptionFrequency[c] = (descriptionFrequency[c] || 0) + 1;
      });
    });

    return orderedUnique.sort((a, b) => {
      const appearsInAllA = descriptionFrequency[a] === filteredMatchedEntries.length;
      const appearsInAllB = descriptionFrequency[b] === filteredMatchedEntries.length;
      if (appearsInAllA && !appearsInAllB) return -1;
      if (!appearsInAllA && appearsInAllB) return 1;
      return a.localeCompare(b);
    });
  };

  // Calculate row total for a specific group
  const calculateRowTotal = (group) => {
    let rowTotal = quotedInstallationTrainingForGroup(group);
    group.entries.forEach((entry) => {
      if (isTrainingExpenseDisplayRow(entry)) return;
      if (entry.value != null && String(entry.value).trim() !== "") {
        rowTotal += parseAmountNumber(entry.value);
      }
    });
    const tripduration = group.entries[0]?.tripduration || 0;
    rowTotal += (perdiem * tripduration) + (averagecost * tripduration);
    return rowTotal;
  };

  const allDescriptions = getAllDescriptions();

  console.log("Gdgdfh", allDescriptions)
  const groupedPersons = groupPersonsByManager;

  return (
    <div ref={AssociatedRef} className="bg-white pt-5 pl-2 rounded-md">
      <div className="text-lg font-semibold pb-2">
        <h2>Associated Costs: Installation</h2>
      </div>
      {filteredMatchedEntries.length ? (

        <div className="">
          <div className="maintable text-xs  inline-block">
            <div className="flex bg-[#e8e8e8] border-r">
              <div className="p-3 text-left w-40 bg-[#e8e8e8] border-b flex justify-start font-semibold align-middle items-center">Task</div>
              {filteredMatchedEntries.map((group, index) => (
                <div key={index} className="px-2 py-2 capitalize w-40 border-b bg-[#e8e8e8] flex justify-center font-semibold align-middle items-center text-center">
                  {getPersonDisplayName(group.taskownerid, groupedPersons)}
                </div>
              ))}
            </div>
            <div className="border">
              {/* Total Row */}
              <div className="flex text-xs font-semibold bg-white border-r">
                <div className="p-3 w-40 flex justify-start align-middle border-b items-center font-semibold">Total ({currency})</div>
                {filteredMatchedEntries.map((group, index) => (
                  <div key={index} className="px-2 py-2  text-xs  w-40 flex justify-center border-b align-middle items-center font-semibold">
                    {formatMoneyComma(calculateRowTotal(group))}
                  </div>
                ))}
              </div>
              {/* Trip Duration Row */}
              <div className="flex bg-white border-r">
                <div className="p-3 w-40 flex justify-start border-b align-middle items-center">Trip Duration (Days)</div>
                {filteredMatchedEntries.map((group, index) => (
                  <div key={index} className="px-2 py-2  w-40 flex justify-center border-b align-middle items-center">
                    {group.entries[0]?.tripduration ?? "-"}
                  </div>
                ))}
              </div>

              {/* Dynamic Description Rows */}
              {/* Dynamic Description Rows */}
              {/* Dynamic Description Rows */}
              <div className="narrow-scrollbar descriptionbox max-h-[196px] overflow-y-auto inline-block border-r">
                {allDescriptions.map((description, descIndex) => (
                  <div
                    key={descIndex}
                    className={`flex `}
                  >
                    <div className={`px-2 py-2 pl-3 w-40 min-h-[48px] flex justify-start border-b align-middle items-center bg-white `}>
                      {description}
                    </div>
                    {filteredMatchedEntries.map((group, groupIndex) => {
                      const rowIsTraining = isTrainingExpenseDisplayRow({ description });
                      const amount = rowIsTraining
                        ? quotedInstallationTrainingForGroup(group)
                        : (() => {
                            const matchedEntry = group.entries.find(
                              (entry) =>
                                canonicalInstallationAssociatedTaskDescription(
                                  entry.description,
                                  currency
                                ) === description
                            );
                            return matchedEntry ? parseAmountNumber(matchedEntry.value) : 0;
                          })();

                      return (
                        <div
                          key={groupIndex}
                          className={`p-3 w-40 min-h-[48px] flex justify-center border-b align-middle items-center text-center bg-white`}
                        >
                          {amount > 0 ? formatMoneyComma(amount) : "-"}
                        </div>
                      );
                    })}
                  </div>
                ))}
              </div>
              {/* Perdiem Row */}
              <div className="flex bg-white border-r">
                <div className="p-3 w-40 flex justify-start border-b align-middle items-center">Perdiem ({currency})</div>
                {filteredMatchedEntries.map((group, index) => (
                  <div key={index} className="px-2 py-2   w-40 flex justify-center border-b align-middle items-center">
                    {USAComma(perdiem * (group.entries[0]?.tripduration || 0))}
                  </div>
                ))}
              </div>

              {/* Average Cost Row */}
              <div className="flex bg-white border-r">
                <div className="p-3  w-40 flex justify-start  border-b align-middle items-center">Average Cost ({currency})</div>
                {filteredMatchedEntries.map((group, index) => (
                  <div key={index} className="px-2 py-2   w-40 flex justify-center border-b align-middle items-center">
                    {USAComma(averagecost * (group.entries[0]?.tripduration || 0))}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <>
          <div className="w-full bg-white flex h-10 border-b">
              <div className="w-full py-3 flex items-center justify-start text-start text-red-500 text-sm font-semibold">
                No data available
            </div>
          </div>
        </>
      )}
    </div>

  );
};

export default SalesFinanceEfforts;